import { WarrantyType } from './generics';

export class DataprevEmployeeCreateModel {
    warrantyType: WarrantyType = 'DataprevEmployee';
    dataprev_EmployerName?: string;
    dataprev_EmployeeCode?: string;
    dataprev_EmployerRegistrationCode?: string;
    dataprev_EmployerRegistrationNumber?: string;
    dataprev_EmployeeAdmissionDate?: string;
    dataprev_DiscountStartPeriod?: string;
    totalValue?: number;

    constructor(obj?: Partial<DataprevEmployeeCreateModel>) {
        Object.assign(this, obj);
    }

    title?() {
        return 'Dataprev - Crédito do Trabalhador';
    }
    description?() {
        return ` Dataprev - Crédito do Trabalhador`;
    }
}
